//jquery
import jquery from 'jquery';
window.jQuery = window.$ = jquery;

//bootstrap
import 'bootstrap';

$(document).ready(function () {
  var
    scrollTop = new ScrollTop()
});

(function($) {

// Check if Navigator is Internet Explorer
    if(navigator.userAgent.indexOf('MSIE')!==-1
        || navigator.appVersion.indexOf('Trident/') > -1){

        // Scroll event check
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();

            // Activate sticky for IE if scrolltop is more than 20px
            if ( scroll > 20) {
                $('.sticky-top').addClass( "sticky-top-ie" );
            }else{
                $('.sticky-top').removeClass( "sticky-top-ie" );
            }

        });

    }

})( jQuery );


// On dropdown open
$(document).on('shown.bs.dropdown', function (event) {
  var dropdown = $(event.target);

  // Set aria-expanded to true
  dropdown.find('.dropdown-menu').attr('aria-expanded', true);

  // Set focus on the first link in the dropdown
  // setTimeout(function () {
  //   dropdown.find('.dropdown-menu li:first-child a').focus();
  // }, 10);
});

// On dropdown close
$(document).on('hidden.bs.dropdown', function (event) {
  var dropdown = $(event.target);

  // Set aria-expanded to false
  dropdown.find('.dropdown-menu').attr('aria-expanded', false);

  // Set focus back to dropdown toggle
  dropdown.find('.dropdown-toggle').focus();
});



$(document).ready(function () {

  $('.collapse').on('shown.bs.collapse', function () {
    $(this).parent().addClass('active');
  });

  $('.collapse').on('hidden.bs.collapse', function () {
    $(this).parent().removeClass('active');
  });

  $(".panel-filter").on("click", function (e) {
    e.stopPropagation();
  });


  $('.close').click(function () {
    $(this).parents('.club-search--item').find('.dropdown-toggle').dropdown('toggle')
  });

  $('.icon-text').click(function (event) {
      setTimeout(function () {
          console.log("444");
          $.fn.matchHeight._update(true, event);
      }, 100);
  });
});


$('.club-search--item-icon a').on('click', function (e) {
  e.preventDefault()
  $(this).tab('show')
  $('.rounded').removeClass('active');
})

/* ======================================================================== */
/* Scroll to Top
/* ======================================================================== */


var ScrollTop = function () {


  var btn = $('#scrolltop');

  $(window).scroll(function () {
    if ($(window).scrollTop() > 800) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, '300');
  });

}

/* ======================================================================== */
/* Audio Player
/* ======================================================================== */

$(document).ready(function() {
    var playing = false;

    $('.audio-play').click(function() {


        if (playing == false) {
            document.getElementById('player').play();
            playing = true;


        } else {
            document.getElementById('player').pause();
            playing = false;

        }

    });
});



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/Js/components/component/jqueryfunction.js
 **/